import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import "react-dropdown-tree-select/dist/styles.css";
import BackBtn from "../../common/BackBtn";
import { HomeIcon } from "../../assets/Icons";

class CreateParentChildBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      maxRange: "",
      minRange: "",
      Listing: [],
      showList: false,
      mcqBankList: [],
      rangeBankList: [],
      selectedRangeBankIdForTask: "",
      rangeIsMandatryP_C: true,
      value: "",
    };
  }

  componentWillMount() {
    var viewtype = sessionStorage.getItem("p_c_bank_listtype");
    var viewdata = JSON.parse(sessionStorage.getItem("p_c_bank_listdata"));

    this.setState({ viewtype: viewtype, viewdata: viewdata });
    if (viewtype == "parent") {
    } else if (viewtype == "child") {
      this.fetchParentChildBank();
    } else {
    }
  }

  fetchParentChildBank = () => {
    var viewdata = JSON.parse(sessionStorage.getItem("p_c_bank_listdata"));
    var data = {
      sid: ud.main_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/ParentChildList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.listParentchild) {
            var r = _this.convert(response.data.listParentchild);
            var temp = r.find((x) => x.id === viewdata.id);
            console.log(temp);
            _this.setState({ Listing: temp });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.fetchParentChildBank();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  convert = (array) => {
    const map = {};
    const roots = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      obj.children = [];
      map[obj.id] = obj;
    }

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      if (obj.parent_id !== null && obj.parent_id !== undefined && map[obj.parent_id]) {
        map[obj.parent_id].children.push(obj);
      } else {
        roots.push(obj);
      }
    }

    return roots;
  };

  onChangeInput = (e) => {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  };
  selectedMcqType = (e) => {
    this.setState({ McqTypeBank: e.target.value });
  };
  onChangeInputCreateParent = (e) => {
    this.setState({ p_c_question_type: e.target.value });
    if (e.target.value == 1) {
      this.fetchMcqBankList();
    } else if (e.target.value == 2) {
      this.fetchRangeBankList();
    } else if (e.target.value == 3) {
      // this.fetchParentChildBankList()
    }
  };
  fetchMcqBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/MCQList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            if (response.data.listMCQ) {
              _this.setState({ mcqBankList: response.data.listMCQ });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchMcqBankList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Error", "Something Went Wrong. Please Retry.", "error");
      });
  };
  fetchRangeBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/RangeList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            if (response.data.listRange) {
              _this.setState({ rangeBankList: response.data.listRange });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchRangeBankList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Error", "Something Went Wrong. Please Retry.", "error");
      });
  };
  submitParent = (e) => {
    var data = {
      sid: ud.main_id,
      question: this.state.question,
      bank_id: 0,
      child_type: 3,
      parent_id: 0,
      is_mandatory: 1,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    let _this = this;
    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal("Success", response.data.message, "success");
            sessionStorage.removeItem("p_c_bank_listdata");
            sessionStorage.removeItem("p_c_bank_listtype");
            window.location.href = "/create/parentchildbanklist";
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.submitParent();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Error","Something Went Wrong. Please Retry.", "error");
      });
  };
  createChild = (data) => {
    this.setState({ showList: true, selectedNodeIDForPC: data.id });
  };
  radioRangeBankSelect = (e) => {
    this.setState({ selectedRangeBankIdForTask: e.target.value });
  };
  handleCheckbox = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.checked });
  };
  saveParentChildBankForC = (child_type) => {
    var data;
    if (child_type == 1) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 1,
        bank_id: this.state.selectedMcqBankIdForTask,
        is_mandatory: this.state.rangeIsMandatryP_C ? 1 : 0,
      };
    } else if (child_type == 2) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 2,
        bank_id: this.state.selectedRangeBankIdForTask,
        is_mandatory: this.state.rangeIsMandatryP_C ? 1 : 0,
      };
    } else if (child_type == 3) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: this.state.question_pc_bank,
        child_type: 3,
        bank_id: 0,
        is_mandatory: 1,
      };
    } else {
      return;
    }

    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal("Success", response.data.message, "success");
            _this.setState({
              selectedRangeBankIdForTask: "",
              selectedMcqBankIdForTask: "",
              p_c_question_type: null,
              selectedNodeIDForPC: undefined,
              showList: false,
            });
            _this.fetchParentChildBank();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.saveParentChildBankForC(child_type);
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Error", "Something Went Wrong. Please Retry.", "error");
      });
  };
  radioMcqBankSelect = (e) => {
    this.setState({ selectedMcqBankIdForTask: e.target.value });
  };
  createBank = (taskType) => {
    this.setState({ SelectedBankTypeForCreateBank: taskType, createBank: true });
  };
  SaveMcqBank = () => {
    var data;
    var _this = this;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        sid: ud.main_id,
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        alternative2: this.state.alt2AnsMcq,
        alternative3: this.state.alt3AnsMcq,
        mcq_type: 1,
      };
    } else {
      data = {
        sid: ud.main_id,
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        mcq_type: 2,
      };
    }
    if (data.question == "" || data.correct == "" || data.alternative1 == "") {
      swal("Question, Option 1, and Option 2 are always compulsory..", "", "warning");
      return;
    }
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/MCQCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            _this.setState({ createBank: false, SelectedBankTypeForCreateBank: undefined });
            _this.fetchMcqBankList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.SaveMcqBank();
              }
            });
          }

          swal("Success", response.data.message, "success");
          return;
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  SaveRangeBank = () => {
    var data = {
      sid: ud.main_id,
      question: this.state.quectionRange,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
    };
    var _this = this;

    if (data.question == "" || data.max_value == "" || data.min_value == "") {
      swal("Question, Max, And Min Is Always Compulsory.", "", "warning");
      return;
    } else if (Number(data.min_value) == Number(data.max_value)) {
      swal("Minimum Value and Maximum Value should not be the same.", "", "warning");
      return;
    }
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/RangeCreate`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal("Success", response.data.message, "success");
            _this.setState({ createBank: false, SelectedBankTypeForCreateBank: undefined });
            _this.fetchRangeBankList();
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.SaveRangeBank();
              }
            });
          }
          return;
        }
      })
      .catch(function (error) {
        swal("Error", "Something Went Wrong. Please Retry.", "error");
      });
  };
  // form validation enter on number
  txtNum(e) {
    this.setState({ inputvalue: e.target.value.replace(/\D/g, "") });
  }

  render() {
    var temp = [this.state.Listing];
    console.log(temp, "Line 416");

    var tree = temp.map((i) => <TreeNode node={i} children={i.children} createChild={this.createChild} />);

    return (
      <div>
        <div class="xp-breadcrumbbar">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <h3 class="xp-page-title">
                <BackBtn /> Create New Library
              </h3>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="xp-breadcrumb gradient-border">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />
                      </i>
                    </a>
                  </li>
                  <li
                    class="breadcrumb-item active"
                    aria-current="page"
                    onClick={() => (window.location.href = "/create/parentchildbanklist")}
                  >
                    List
                  </li>
                  <li
                    class="breadcrumb-item active"
                    aria-current="page"
                    onClick={() => (window.location.href = "/create/parentchildbankcreate")}
                  >
                    Edit
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="xp-contentbar p-30">
          <div className="row">
            <div className="col-lg-12">
              {this.state.showList === false ? (
                <div className="card document_gradient_border padding-0 m-b-30">
                  <div className="card-header border-radius-top-15">
                    <h5 className="card-title">Create New Library</h5>
                  </div>
                  {this.state.viewtype === "parent" ? (
                    <div className="card-body">
                      <div className="form-row">
                        <div className="form-group col-md-12">
                          <label for="exampleInputEmail1">Question / Step</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="question"
                            className="form-control"
                            placeholder="Enter Question"
                          />
                        </div>
                      </div>

                      <button onClick={this.submitParent} className="btn btn-primary mt-3">
                        Submit
                      </button>
                    </div>
                  ) : null}

                  {this.state.viewtype === "child" ? <div className="card-body">{tree}</div> : null}
                </div>
              ) : (
                <div className="card document_gradient_border padding-0 m-b-30">
                  <div className="card-header border-radius-top-15">
                    <h5 className="card-title">Select Library</h5>
                  </div>
                  <div class="card-body pr-2 pl-3">
                    <h4>Add Question Hierarchy </h4>
                    <div class="py-3 d-flex lib-btn">
                      <div className="item">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="in-1"
                            value="1"
                            onChange={this.onChangeInputCreateParent}
                            name="p_c_question_type"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="in-1">
                            MCQ
                          </label>
                        </div>
                      </div>
                      <div className="item">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="in-2"
                            value="2"
                            onChange={this.onChangeInputCreateParent}
                            name="p_c_question_type"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="in-2">
                            Range
                          </label>
                        </div>
                      </div>
                      <div className="item">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="in-3"
                            value="3"
                            onChange={this.onChangeInputCreateParent}
                            name="p_c_question_type"
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for="in-3">
                            Question Hierarchy
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.createBank && this.state.SelectedBankTypeForCreateBank != undefined ? (
                    <div>
                      {this.state.SelectedBankTypeForCreateBank === "MCQ" ? (
                        <div>
                          <div className="card-header bg-white heading-cont pb-0">
                            <h4>Create MCQ Library</h4>
                            <div onClick={() => this.setState({ createBank: false })}>
                              <svg
                                className="bi bi-x-circle-fill"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="card-body pt-0">
                            <div className="form-row">
                              <div className="form-group col-md-6">
                                <h5 className="card-title text-black">MCQ Type :</h5>
                                <div className="form-group py-3">
                                  <div className="custom-control custom-radio custom-control-inline">
                                    <input
                                      type="radio"
                                      value="mcq"
                                      id="customRadioInline4"
                                      name="SelectMcqType"
                                      onChange={this.selectedMcqType}
                                      className="custom-control-input"
                                    />
                                    <label className="custom-control-label" for="customRadioInline4">
                                      4 Options
                                    </label>
                                  </div>
                                  <div className="custom-control custom-radio custom-control-inline">
                                    <input
                                      type="radio"
                                      value="yesno"
                                      id="customRadioInline5"
                                      name="SelectMcqType"
                                      onChange={this.selectedMcqType}
                                      className="custom-control-input"
                                    />
                                    <label className="custom-control-label" for="customRadioInline5">
                                      2 Options
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="sticky-fixed pr-2">
                              <div className="form-group">
                                <label for="exampleInputEmail1">Question / Step</label>
                                <input
                                  type="text"
                                  onChange={this.onChangeInput}
                                  name="quectionMcq"
                                  className="form-control"
                                  placeholder="Enter Question"
                                />
                              </div>

                              {this.state.McqTypeBank === "mcq" ? (
                                <div>
                                  <div className="form-group">
                                    <label className="text-success" for="exampleInputEmail1">
                                      Option 1 (Correct)
                                    </label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="correctAnsMcq"
                                      value={this.state.correctAnsMcq}
                                      className="form-control border-success"
                                      placeholder="Enter Option 1"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label for="exampleInputEmail1">Option 2 (Wrong)</label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="alt1AnsMcq"
                                      value={this.state.alt1AnsMcq}
                                      className="form-control"
                                      placeholder="Enter Option 2"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label for="exampleInputEmail1">Option 3 (Wrong)</label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="alt2AnsMcq"
                                      value={this.state.alt2AnsMcq}
                                      className="form-control"
                                      placeholder="Enter Option 3"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label for="exampleInputEmail1">Option 4 (Wrong)</label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="alt3AnsMcq"
                                      value={this.state.alt3AnsMcq}
                                      className="form-control"
                                      placeholder="Enter Option 4"
                                    />
                                  </div>
                                  <div className="form-row">
                                    <div className="form-group customcheckbox m-2">
                                      <label>
                                        <input
                                          type="checkbox"
                                          name="mcqIsMandatry"
                                          onChange={this.handleCheckbox}
                                          checked={this.state.mcqIsMandatry}
                                        />
                                        <span className="checkmark"></span>
                                        Is Mandatory
                                      </label>
                                    </div>
                                    {/* <div className="form-group customcheckbox ml-5">
                                      <label>
                                        <input
                                          type="checkbox"
                                        //   className="ml-2 mr-2"
                                          name="mcqIsMandatry"
                                          onChange={this.handleCheckbox}
                                          checked={this.state.mcqIsMandatry}
                                        />
                                        Is Mandatory
                                      </label>
                                    </div> */}
                                  </div>
                                  <button
                                    onClick={this.SaveMcqBank}
                                    type="button"
                                    className="btn btn-primary mt-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}

                              {this.state.McqTypeBank === "yesno" ? (
                                <div>
                                  <div className="form-group">
                                    <label className="text-success" for="exampleInputEmail1">
                                      Option 1 (Correct)
                                    </label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="correctAnsMcq"
                                      value={this.state.correctAnsMcq}
                                      className="form-control border-success"
                                      placeholder="Enter Option 1"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label for="exampleInputEmail1">Option 2 (Wrong)</label>
                                    <input
                                      type="text"
                                      onChange={this.onChangeInput}
                                      name="alt1AnsMcq"
                                      value={this.state.alt1AnsMcq}
                                      className="form-control"
                                      placeholder="Enter Option 2"
                                    />
                                  </div>

                                  <button
                                    onClick={this.SaveMcqBank}
                                    type="button"
                                    className="btn btn-primary"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.SelectedBankTypeForCreateBank === "Range" ? (
                        <div>
                          <div className="card-header bg-white heading-cont">
                            <h5 className="card-title text-black">Create Range Library</h5>
                            <div onClick={() => this.setState({ createBank: false })}>
                              <svg
                                className="bi bi-x-circle-fill"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="card-body pt-0">
                            <div className="form-group">
                              <label for="exampleInputEmail1">Question / Step</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="quectionRange"
                                className="form-control"
                                placeholder="Enter Question"
                              />
                            </div>
                            <div className="form-group">
                              <label for="exampleInputEmail1">Min Range</label>
                              <input
                                type="number"
                                onChange={this.onChangeInput}
                                name="minRange"
                                className="form-control"
                                placeholder="Enter Min Range"
                              />
                            </div>
                            <div className="form-group">
                              <label for="exampleInputEmail1">Max Range</label>
                              <input
                                type="number"
                                onChange={this.onChangeInput}
                                name="maxRange"
                                className="form-control"
                                placeholder="Enter Max Range"
                              />
                            </div>

                            <button
                              onClick={this.SaveRangeBank}
                              type="button"
                              className="btn btn-primary mt-2"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Add"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <div>
                      {this.state.p_c_question_type == "1" ? (
                        <div className="card-body pt-0">
                          <div class="sticky-fixed">
                            <div
                              class="form-row dv-center space-between"
                              style={{
                                position: "sticky",
                                top: "0",
                                background: "#fff",
                                padding: "10px",
                                zIndex: "999",
                              }}
                            >
                              <div>
                                {/* <div className="form-group customcheckbox">
                                  <input
                                    type="checkbox"
                                    className="mr-2"
                                    name="rangeIsMandatryP_C"
                                    onChange={this.handleCheckbox}
                                    checked={this.state.rangeIsMandatryP_C}
                                  />
                                  Is Mandatory
                                </div> */}
                                <div className="form-group customcheckbox">
                                  <label>
                                    <input
                                      type="checkbox"
                                      name="rangeIsMandatryP_C"
                                      onChange={this.handleCheckbox}
                                      checked={this.state.rangeIsMandatryP_C}
                                    />
                                    <span className="checkmark"></span>
                                    Is Mandatory
                                  </label>
                                </div>
                              </div>
                              <div>
                                <button
                                  type="button"
                                  onClick={() => this.createBank("MCQ")}
                                  className="btn btn-primary ml-2"
                                >
                                  <i className="mdi mdi-plus mr-2"></i> Create
                                </button>

                                <button
                                  onClick={() => this.saveParentChildBankForC(1)}
                                  type="button"
                                  className="btn btn-primary ml-2"
                                >
                                  <i class="mdi mdi-plus mr-2 "></i> Add
                                </button>
                              </div>
                            </div>

                            {this.state.mcqBankList.map((list, index) => (
                              <div className="item">
                                <div class="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    id={`customRadio${index + 10}`}
                                    value={list.id}
                                    onChange={this.radioMcqBankSelect}
                                    name="mcqBankRadio"
                                    class="custom-control-input"
                                  />
                                  <label class="custom-control-label" for={`customRadio${index + 10}`}>
                                    {list.question}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      {this.state.p_c_question_type == "2" ? (
                        <div className="card-body">
                          <div
                            class="form-row dv-center space-between"
                            style={{ position: "sticky", top: "0", background: "#fff", padding: "10px", zIndex: "999" }}
                          >
                            <div>
                              {/* <div className="form-group dv-center ml-3">
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  name="rangeIsMandatryP_C"
                                  onChange={this.handleCheckbox}
                                  checked={this.state.rangeIsMandatryP_C}
                                />
                                Is Mandatory
                              </div> */}
                              <div className="form-group customcheckbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    name="rangeIsMandatryP_C"
                                    onChange={this.handleCheckbox}
                                    checked={this.state.rangeIsMandatryP_C}
                                  />
                                  <span className="checkmark"></span>
                                  Is Mandatory
                                </label>
                              </div>
                            </div>
                            <div>
                              <button
                                type="button"
                                onClick={() => this.createBank("Range")}
                                className="btn btn-primary ml-2"
                              >
                                <i className="mdi mdi-plus mr-2"></i> Create
                              </button>

                              <button
                                onClick={() => this.saveParentChildBankForC(2)}
                                type="button"
                                class="btn btn-primary ml-2 "
                              >
                                <i class="mdi mdi-plus mr-2 "></i> Add
                              </button>
                            </div>
                          </div>
                          <div class="mt-2  sticky-fixed">
                            {this.state.rangeBankList.map((list, index) => (
                              <div className="item">
                                <div class="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    id={`customRadio${index + 10}`}
                                    value={list.id}
                                    onChange={this.radioRangeBankSelect}
                                    name="rangeBankRadio"
                                    class="custom-control-input"
                                  />
                                  <label class="custom-control-label" for={`customRadio${index + 10}`}>
                                    {list.question}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      {this.state.p_c_question_type == "3" ? (
                        <div className="card-body">
                          <div class="form-content text-center">
                            <input
                              type="text"
                              onChange={this.onChangeInput}
                              class="form-control"
                              name="question_pc_bank"
                              id="inputText"
                              placeholder="Question..."
                            />
                            <button
                              onClick={() => this.saveParentChildBankForC(3)}
                              type="button"
                              class="btn btn-primary mt-3"
                            >
                              <i class="mdi mdi-plus mr-2"></i> Add
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CreateParentChildBank;

class TreeNode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };

    // this.handleClick = this.handleClick.bind(this);
  }
  getInitialState = () => {
    return { isVisible: false };
  };

  toggle = (e) => {
    this.setState({ isVisible: !this.state.isVisible });
  };
  getChild = (prop) => {
    prop.selectNode(prop.node.id);
  };
  editChild = (prop) => {
    prop.editNode(prop.node);
  };

  render() {
    var icon = this.state.isVisible ? "fa fa-angle-up" : "fa fa-angle-down";
    var span;
    var nodes;
    console.log(this.props.children, "line 1027");

    if (this.props.children && this.props.children.length > 0) {
      span = (
        <span className="icon" onClick={this.toggle}>
          <i className={icon}></i>
        </span>
      );

      if (this.state.isVisible) {
        nodes = this.props.children.map((i) => (
          <TreeNode node={i} children={i.children} createChild={this.props.createChild} />
        ));
      }
    }

    return (
      <ul className="parent-accordian questionhirarchy">
        <li className="accordion-item pc-card">
          <div className="accordion-title-parent">
            {span}
            <div className="bag-icon dv-center">
              <div className="icons-con mr-2">
                {this.props.node.child_type === 3 ? <i class="fa fa-sitemap"></i> : null}
                {this.props.node.child_type === 1 ? <i class="fa fa-th-list"></i> : null}
                {this.props.node.child_type === 2 ? <i class="fa fa-sort-numeric-up-alt"></i> : null}
              </div>
              {this.props.node.question}
            </div>

            <div class="act-btn">
              {this.props.node.child_type === 3 ? (
                <button
                  className="btn btn-sm btn-primary"
                  title="Add"
                  onClick={() => this.props.createChild(this.props.node)}
                >
                  <i className="mdi mdi-library-plus mr-2"></i>Add
                </button>
              ) : null}

              {/* <button className="button2">
                            <svg class="bi bi-pencil" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 011.414 0l2 2a1 1 0 010 1.414l-9 9a1 1 0 01-.39.242l-3 1a1 1 0 01-1.266-1.265l1-3a1 1 0 01.242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" clip-rule="evenodd" />
                                <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 00.5.5H4v.5a.5.5 0 00.5.5H5v.5a.5.5 0 00.5.5H6v-1.5a.5.5 0 00-.5-.5H5v-.5a.5.5 0 00-.5-.5H3z" clip-rule="evenodd" />
                            </svg>

                        </button> */}
            </div>
          </div>
          <ul className="accordion-content">{nodes}</ul>
        </li>
      </ul>
    );
  }
}
